export default __webpack_public_path__ + "static/media/the-singing-one.85aec6b2.png";